import { Component, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { BaseCellEditor } from './base-editor';
import { CELL_EDITOR_STYLES } from './cell-editor.styles';

/**
 * Checkbox is unique: it toggles immediately on click (no edit mode needed).
 * This editor is shown inline, not in a popup.
 */
@Component({
  selector: 'ct-checkbox-editor',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <label class="cell-checkbox-label">
      <input type="checkbox" class="cell-checkbox"
        tabindex="-1"
        [checked]="isChecked"
        (change)="onToggle($event)"
        (keydown)="onCheckKeydown($event)"
        tabindex="-1"
        aria-hidden="true" />
      <span class="cell-checkbox-visual" [class.checked]="isChecked" aria-hidden="true">
        <lucide-angular *ngIf="isChecked" name="check" [size]="12" [color]="'white'" aria-hidden="true"></lucide-angular>
      </span>
    </label>
  `,
  styles: [CELL_EDITOR_STYLES, `
    .cell-checkbox-label { display: flex; align-items: center; justify-content: center; cursor: pointer; width: 100%; height: 100%; }
    .cell-checkbox { position: absolute; opacity: 0; width: 0; height: 0; }
    .cell-checkbox-visual {
      width: 20px; height: 20px;
      border: 2px solid var(--og-secondary, #546574);
      border-radius: var(--og-radius-sm, 4px);
      display: flex; align-items: center; justify-content: center; transition: all 0.15s;
    }
    .cell-checkbox-visual.checked {
      background: var(--og-primary, #4b3fff);
      border-color: var(--og-primary, #4b3fff);
    }
    .cell-checkbox:focus + .cell-checkbox-visual {
      outline: 2px solid var(--og-primary, #4b3fff);
      outline-offset: 2px;
    }
  `],
})
export class CheckboxEditorComponent extends BaseCellEditor implements OnChanges {
  isChecked = false;

  ngOnChanges(): void {
    const v = this.value;
    const s = String(v).toLowerCase();
    this.isChecked = v === true || v === 1 || s === '1' || s === 'true' || s === 'yes' || s === 'on';
    this.editingValue = this.isChecked;
  }

  onToggle(event: Event): void {
    this.isChecked = (event.target as HTMLInputElement).checked;
    this.editingValue = this.isChecked;
    this.save.emit(this.isChecked);
  }

  onCheckKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      this.cancel.emit();
    } else if (event.key === 'Tab') {
      event.preventDefault();
      event.stopPropagation();
      this.tabSave.emit({ value: this.editingValue, shiftKey: event.shiftKey });
    }
  }

}
